import { useQuery, useMutation } from '@apollo/react-hooks';
import React, { useEffect, useState } from 'react';
import { Edit, Settings, Eye, Trash } from '@jda/lui-common-icon-library';
import { useSnackbar } from 'notistack';
import DetailedTable from '../../components/DetailedTable';
import { USER_DETAILS, FETCH_USERS, DELETE_USER, GET_USER } from '../graphQL/queries';
import { Button, makeStyles, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@material-ui/core';
import { Loading } from '../../Loading';
import AddUserDialog from '../../components/GlobalUsers/AddUserDialog';
import ViewUserDialog from '../../components/GlobalUsers/ViewUserDialog';
import { usersColumns } from '../../components/GlobalUsers/userFormDataConfig';

const searchColumns = ['userName', 'firstName', 'lastName'];

const useStyles = makeStyles(theme => ({
  buttonMargin: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1)
  }
}));

const Users = () => {
  const classes = useStyles();
  const [addUser, setAddUser] = useState(false);
  const [viewUser, setViewUser] = React.useState<any>(false);
  const [editUser, setEditUser] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [userData, setUserData] = React.useState<any>({});
  const [formInfo, setFormInfo] = React.useState<any>({});
  const [confimationPopover, setConfirmationPopover] = useState(false);
  const [inputText, setInputText] = React.useState('');
  const [data, setData] = React.useState<any>([]);

  const { data: user } = useQuery(USER_DETAILS, {});
  const [deleteUser] = useMutation(DELETE_USER);
  const { loading, data: usersData, refetch } = useQuery(FETCH_USERS, {});

  let formatData: any[] = [];

  usersData?.userProfile?.data &&
    usersData.userProfile.data.length &&
    usersData.userProfile.data.map(
      (
        item: {
          [x: string]: any;
          user: { firstName: any; lastName: any; creationDate: any; lastLoginDate: any; lmd: any };
        },
        index: any
      ) => {
        let { firstName, lastName, creationDate, lastLoginDate, lmd } = item?.user;
        item.firstName = firstName;
        item.lastName = lastName;
        item.creationDate = creationDate;
        item.lastLoginDate = lastLoginDate;
        item.lmd = lmd;
        formatData.push(item);
      }
    );

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setData(usersData?.userProfile?.data);
    setUserRole(user?.userProfile?.roles?.[0]);
  }, [user, usersData]);

  const openAddUserModal = () => {
    setAddUser(true);
    setFormInfo({});
    setEditUser(false);
  };

  const closeAddUserModal = () => {
    setAddUser(false);
    setFormInfo({});
  };

  const submitAddUserModal = () => {
    setAddUser(false);
    refetch();
  };

  const closeViewUserModal = () => {
    setViewUser(false);
  };
  const openViewUserModal = (rowData: any) => {
    setViewUser(!viewUser);
    setUserData(rowData);
  };
  const openEditUserModal = (rowData: any) => {
    setEditUser(true);
    setUserData({ ...rowData });
    setAddUser(true);
  };

  const handleDeleteConfirmation = (rowData: any) => {
    setUserData(rowData);
    setConfirmationPopover(true);
  };

  const closeDeleteConfirmationPopover = (rowData: any) => {
    setConfirmationPopover(false);
  };

  const handleDeleteUser = () => {
    deleteUser({
      variables: {
        userName: userData?.userName
      }
    })
      .then(response => {
        refetch();
        enqueueSnackbar('User deleted successfully !!', { variant: 'success', preventDuplicate: true });
        setConfirmationPopover(false);
        return response;
      })
      .catch(error => {
        enqueueSnackbar('Unable to delete User', { variant: 'error', preventDuplicate: true });
        setConfirmationPopover(false);
      });
  };

  const onSearchChange = (searchKey: string) => {
    setInputText(searchKey);
    const participantResult = usersData?.userProfile?.data;
    const filteredData = participantResult?.filter((row: any) => {
      return String(searchColumns.map(column => String(row[column]).toLowerCase())).includes(searchKey.toLowerCase());
    });
    setData(filteredData);
  };

  const usersTableActions: any = [
    userRole === 'APP_ADMIN' && {
      icon: () => (
        <Button
          variant="outlined"
          onClick={openAddUserModal}
          data-id="new-participant"
          id="new-participant"
          color="primary"
        >
          Add User
        </Button>
      ),
      onClick: () => {},
      isFreeAction: true
    },
    userRole &&
      userRole === 'APP_SUPPORT' && {
        icon: () => <Eye data-id="edit-enable-service" />,
        onClick: (event: any, rowData: any) => openViewUserModal(rowData),
        tooltip: 'View User Datails',
        position: 'row'
      },
    userRole &&
      userRole === 'APP_ADMIN' && {
        icon: () => <Edit data-id="edit-user-service" />,
        onClick: (event: any, rowData: any) => openEditUserModal(rowData),
        tooltip: 'Edit User',
        position: 'row'
      },
    userRole &&
      userRole === 'APP_ADMIN' && {
        icon: () => <Trash data-id="delete-user-service" />,
        onClick: (event: any, rowData: any) => handleDeleteConfirmation(rowData),
        tooltip: 'Delete User',
        position: 'row'
      }
  ];
  return (
    <React.Fragment>
      <AddUserDialog
        edit={editUser}
        formData={userData}
        dialogOpen={addUser}
        refresh={refetch}
        formInfo={formInfo}
        handleDialogOpen={openAddUserModal}
        handledialogclose={closeAddUserModal}
        handleDialogSubmit={submitAddUserModal}
        usersData={data}
      />
      <ViewUserDialog handleDialog={closeViewUserModal} dialogOpen={viewUser} userData={userData} />
      {loading ? (
        <Loading />
      ) : (
        <DetailedTable
          id={'usersGrid'}
          data={data}
          columns={usersColumns}
          title="Users"
          tableActions={usersTableActions}
          showPagination={true}
          showTopPagination={true}
          showSearch={true}
          onSearchChange={onSearchChange}
        />
      )}
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={confimationPopover}
        onClose={closeDeleteConfirmationPopover}
        id={'delete-user-confirmation'}
        key={'delete-user-confirmation'}
      >
        <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
        <DialogContent dividers>
          <Typography>Are you sure to delete the User?</Typography>
        </DialogContent>
        <DialogActions>
          <div>
            <Button
              data-id="Disable-Button"
              className={classes.buttonMargin}
              variant="outlined"
              color="primary"
              disableElevation
              onClick={handleDeleteUser}
            >
              Delete
            </Button>
            <Button
              data-id="Cancel-Button"
              className={classes.buttonMargin}
              variant="outlined"
              color="primary"
              disableElevation
              onClick={closeDeleteConfirmationPopover}
            >
              Cancel
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Users;
